import React, { useState, useEffect, useLayoutEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { findIndex, find, map } from "lodash";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";

import { Box } from "@mui/system";
import IconButton from "@mui/material/IconButton";
import InstructionCard from "../../Components/Card/AssetUI/InstructionCard";
import MediaCard from "../../Components/Card/AssetUI/MediaCard";
import CBTFooterCard from "../../Components/Card/AssetUI/CBTFooterCard";
import ILTFooterCard from "../../Components/Card/AssetUI/ILTFooterCard";
import ContentTypeCheck from "./ContentTypeCheck";
import { userLogs, durationCalculate, getUserLogs } from "../../Js/Common";
import { currentAssetSliceActions } from "../../Store/Slices/CurrentAssetSlice";
import { getAsset } from "../../Js/Common";
import { unicodeToString, randomNumber, checkLearner } from "../../Js/Common";
import RatingModal from "../../Components/Modal/RatingModal";
import UserAnswers from "./UserAnswers";
import AutoAssignModal from "../../Components/Modal/AutoAssignModal";
import { getFormatedDateTime } from "../../Js/TimeAndDate";
import {
  autoCreateTask,
  autoCreateAssignment,
  prepareAssignObj,
} from "../../Js/AutoAssign";
import { upsertSelfLearnProgress, updateLog } from "./Services";

import MoveDownIcon from "@mui/icons-material/MoveDown";
import { Alert, Menu, MenuItem } from "@mui/material";
import Confirmation from "../../Components/Modal/Confirmation";
import Snackbar from "@mui/material/Snackbar";
import SignalWifiStatusbarConnectedNoInternet4Icon from "@mui/icons-material/SignalWifiStatusbarConnectedNoInternet4";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { getTasksData } from "../Assignment/Services";

const manualEvalAssetTypes = ["DIC", "BOOK", "REC", "NB", "WORD", "RECADV"];
const ILTTypeAssets = ["MEDIA", "ILT", "OP", "CI", "AVP", "RA"];
const FullWidthAssets = ["WORD", "WS", "BINGO"];
const AUTO_SECONDS = 20000;
let autoInsertLogFlg = false;
let interval;

const Content = (props) => {
  // Hooks
  const navigation = useNavigate();
  const location = useLocation();
  const {
    assetId,
    taskId,
    assets,
    sessionId,
    moduleId,
    nodeId,
    id,
    assignmentId,
  } = useParams();
  const dispatch = useDispatch();
  const { serverRole } = useSelector((state) => state.defs);

  // State
  const [assetsList, setAssetsList] = useState([]);
  const [currentAssetIndex, setCurrentAssetIndex] = useState(0);
  const [assetData, setAssetData] = useState(null);
  const [evalMode, setEvalMode] = useState("auto");
  const [ratingVisible, setRatingVisible] = useState(false);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [isViewOnlyWithoutAttempt, setIsViewOnlyWithoutAttempt] =
    useState(false);
  const [autoAssignVisible, setAutoAssignVisible] = useState(false);
  const [autoAssignViewData, setAutoAssignViewData] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [errVisible, setErrVisible] = useState(false);
  const [errMsg, setErrMsg] = useState(false);
  const [ignoreNextPre, setIgnoreNextPre] = useState(false);
  const [defaultRatingLog, setDefaultRatingLog] = useState(null);

  const [stateSnackbar, setStateSnackbar] = useState({
    open1: false,
    vertical: "bottom",
    horizontal: "center",
  });
  const { vertical, horizontal, open1 } = stateSnackbar;

  const open = Boolean(anchorEl);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const product = useSelector((state) => state.product.productData);
  const {
    assetLogObj,
    sessionUid,
    trainerContinueTeachingClass,
    trainerContinueTeachingClassName,
    trainerContinueTeachingLog,
    duration,
    durationStartTimeStamp,
    showAnswer,
    refreshClick,
    timeUp,
  } = useSelector((state) => state.currentAsset);
  const productId = useSelector(
    (state) => state.defs.siteConfig.products[0]["productId"]
  );
  const language = useSelector((state) => state.product.language);
  const { breadcrumb, clickPass } = useSelector((state) => state.common);
  const { siteConfig } = useSelector((state) => state.defs);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem("assignmentAssets");
      sessionStorage.removeItem("lastContext");
      sessionStorage.removeItem("assetId");
      dispatch(currentAssetSliceActions.resetState());
      // For back button to clear interval
      clearInterval(interval);
      dispatch(currentAssetSliceActions.stopDuration());
      dispatch(currentAssetSliceActions.setDurationFlag(false));
      autoInsertLogFlg = false;
    };
  }, []);

  useEffect(() => {
    if (
      !location.pathname.includes("Report") &&
      !location.pathname.includes("Task")
    ) {
      let assets = sessionStorage.getItem("assignmentAssets");
      let lastContext = sessionStorage.getItem("lastContext");
      lastContext = JSON.parse(lastContext);
      if (assets) {
        setAssetsList(JSON.parse(assets));
        if (lastContext) {
          let lastIndex = findIndex(JSON.parse(assets), {
            taskID: lastContext.taskID,
            id: lastContext.assetId,
          });
          console.log("lastIndex", lastIndex);
          setCurrentAssetIndex(lastIndex + 1);
        }
      } else {
        let module;
        if (language > -1) {
          module = find(
            JSON.parse(product[0]["course_data"])["data"][0]["data"][language][
              "data"
            ],
            { id: moduleId }
          );
        } else {
          module = find(
            JSON.parse(product[0]["course_data"])["data"][0]["data"],
            { id: moduleId }
          );
        }
        let session = find(module.data, { id: sessionId });
        let node = find(session.data, { id: nodeId });
        let leaf = find(node.data, { id: id });
        console.log("leaf.data", leaf.data);
        setAssetsList(leaf.data);
        // if (lastContext) {
        //   let lastIndex = findIndex(leaf.data, {
        //     id: lastContext.assetId,
        //   });
        //   setCurrentAssetIndex(lastIndex + 1);
        // }
      }
    } else if (location.pathname.includes("Task")) {
      setAssetsList([{ id: id }]);
      setIsViewOnlyWithoutAttempt(true);
      dispatch(currentAssetSliceActions.setShowAnswer(true));
    } else {
      setAssetsList([{ id: id }]);
      setIsViewOnly(true);
      dispatch(currentAssetSliceActions.setShowAnswer(true));
    }
  }, []);

  useEffect(() => {
    getAssetData();
    setTimeout(() => {
      setIgnoreNextPre(true);
    }, [1000]);
  }, [currentAssetIndex]);

  useEffect(() => {
    if (assetLogObj && assetLogObj.assetType.value) {
      if (userInfo.rolesInfo.title.toLowerCase() == "trainer") {
        startInterval();
      }
    }
  }, [assetLogObj]);

  useLayoutEffect(() => {
    if (userInfo.rolesInfo.title.toLowerCase() == "trainer") {
      document.addEventListener("visibilitychange", onVisibilityChange);
      return () =>
        document.removeEventListener("visibilitychange", onVisibilityChange);
    }
  }, [duration, durationStartTimeStamp]);

  useEffect(() => {
    let assetId = sessionStorage.getItem("assetId");
    if (assetsList && assetsList.length > 0 && !assetId) {
      getAssetData();
    }
    if (assetId) {
      let index = findIndex(assetsList, { id: assetId });
      setCurrentAssetIndex(index + 1);
    }
  }, [assets, assetsList]);

  useEffect(() => {
    if (isViewOnly || isViewOnlyWithoutAttempt) {
      dispatch(currentAssetSliceActions.setShowAnswer(true));
    }
  }, [showAnswer, isViewOnly]);

  useEffect(() => {
    if (refreshClick) {
      let myId = assetData.asset_uid;
      let assetDataLocal = { ...assetData };
      assetDataLocal.asset_uid = null;
      setAssetData(assetDataLocal);
      setTimeout(() => {
        assetDataLocal.asset_uid = myId;
        setAssetData(assetDataLocal);
        dispatch(currentAssetSliceActions.setRefreshClick(false));
      }, [500]);
    }
  }, [refreshClick]);

  useEffect(() => {
    if (clickPass) {
      if (userInfo.rolesInfo.title.toLowerCase() == "trainer") {
        if (currentAssetIndex + 1 < assetsList.length) {
          dropLog("next");
          dispatch(commonSliceActions.setClickPass(false));
          navigation(-1);
        } else {
          dropLog("finish");
          dispatch(commonSliceActions.setClickPass(false));
        }
      } else {
        navigation(-1);
      }
    }
  }, [clickPass]);

  let startInterval = () => {
    // interval = setInterval(() => {
    //   console.log("autoInsertLogFlg====>", autoInsertLogFlg);
    //   if (autoInsertLogFlg == false) {
    //     // console.log('Hello');
    //     insertIntervalDropLog();
    //     autoInsertLogFlg = true;
    //   } else {
    //     // console.log('Bye',autoInsertLogFlg);
    //     updateIntervalDropLog();
    //   }
    // }, AUTO_SECONDS);
  };

  let dropLog = async (actionType, assetMode = null) => {
    //Next and Previous button clear interval
    clearInterval(interval);
    let tempLog = assetLogObj;
    if (
      userInfo.rolesInfo.title.toLowerCase() == "learner" &&
      ILTTypeAssets.indexOf(assetLogObj.assetType.value) > -1
    ) {
      tempLog = {
        ...tempLog,
        duration: durationCalculate(0, durationStartTimeStamp),
      };
    }
    let logObj = {
      actor: userInfo.uid,
      verb: null,
      outcome: tempLog,
      site_uuid: userInfo.site_uuid,
      target: null,
      context: {},
      session_uid: null,
    };
    let logResponse;
    if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      logObj["verb"] = "attemptAssignment";
      logObj["session_uid"] = sessionUid;
      logObj["target"] = assignmentId;
      logObj["context"] = {
        taskID: assetsList[currentAssetIndex]["taskID"],
        assetId: assetsList[currentAssetIndex]["id"],
      };
      logResponse = await userLogs(logObj);
    } else {
      if (autoInsertLogFlg == false) {
        logObj["verb"] = "courseView";
        logObj["context"] = {
          assetId: assetsList[currentAssetIndex]["id"],
          classId: trainerContinueTeachingClass,
          className: trainerContinueTeachingClassName,
          topicPath: breadcrumb,
        };
        logObj["outcome"] = {
          ...assetLogObj,
          duration: durationCalculate(duration, durationStartTimeStamp),
        };
        logResponse = await userLogs(logObj);
      } else {
        logResponse = await updateIntervalDropLog();
      }
      autoInsertLogFlg = false;
    }

    console.log("SSSSSSlogResponse", logResponse);
    dispatch(currentAssetSliceActions.resetDuration());
    dispatch(currentAssetSliceActions.setDurationFlag(true));

    if (logResponse && logResponse.status == 200) {
      if (actionType == "next") {
        setCurrentAssetIndex(currentAssetIndex + 1);
      }
      if (actionType == "previous") {
        setCurrentAssetIndex(currentAssetIndex - 1);
      }
      setIgnoreNextPre(false);
    } else {
      // setErrMsg('Your network connection was disrupted. We shall be with you soon.');
      // setErrVisible(true);
      setStateSnackbar({ ...stateSnackbar, open1: true });
      return false;
    }

    if (userInfo.rolesInfo.title.toLowerCase() == "trainer") {
      continueTeachingLog(
        assetsList[currentAssetIndex]["id"],
        id,
        actionType,
        assetMode
      );
    } else {
      if (
        userInfo.rolesInfo.title.toLowerCase() == "learner" &&
        actionType == "finish"
      ) {
        if (siteConfig.customer?.addOnInfo?.isSelfLearning) {
          let taskData = await getTasksData(
            assetsList[currentAssetIndex]["taskID"],
            userInfo.site_uuid
          );
          dispatch(commonSliceActions.setLoader(true));
          let logupdated = await upsertSelfLearnProgress(
            userInfo.uid,
            assignmentId,
            userInfo.site_uuid,
            taskData.data[0]["tags"]["tags"].indexOf("Special Assessment") > -1
              ? "extraLog"
              : "regularLog"
          );
          if (logupdated) {
            if (
              taskData.data[0]["tags"]["tags"].indexOf("Special Assessment") >
              -1
            ) {
              dropSpecialAssessmentLog();
            }
            dispatch(commonSliceActions.setLoader(false));
          }
        }
        setRatingVisible(true);
        dropDefaultRating(1);
      } else if (actionType == "finish") {
        navigation(-1);
      }
    }
    dispatch(currentAssetSliceActions.startDuration());
  };

  let ratingDone = async (rating) => {
    if (defaultRatingLog && defaultRatingLog.uid) {
      let logResponse = await updateLog(
        { session_uid: sessionUid, learnerRating: rating },
        null,
        defaultRatingLog.uid,
        userInfo.site_uuid
      );
      if (logResponse) {
        setRatingVisible(true);
        navigation(-1);
      }
    }
  };

  const continueTeachingLog = async (
    assetId,
    leafId,
    actionType,
    assetMode
  ) => {
    let logObj = {
      actor: userInfo.uid,
      verb: "continueTeaching",
      outcome: {
        leafId: leafId,
        status: "pending",
        classId: trainerContinueTeachingClass,
      },
      site_uuid: userInfo.site_uuid,
      target: null,
      context: {
        assetId: assetId,
      },
    };

    if (actionType == "finish") {
      logObj["outcome"]["status"] = "completed";
    }
    console.log("SSSSS", trainerContinueTeachingLog);
    let learners = await checkLearner(
      trainerContinueTeachingClass?.toLowerCase()
    );
    if (trainerContinueTeachingLog) {
      console.log("trainerContinueTeachingLog", trainerContinueTeachingLog);
      let updatedLogResponse = await updateLog(
        logObj["outcome"],
        logObj["context"],
        trainerContinueTeachingLog["uid"],
        userInfo.site_uuid
      );
      if (updatedLogResponse.status == 200 && actionType == "finish") {
        dispatch(currentAssetSliceActions.setTrainerContinueTeachingLog(null));
        if (
          assetMode == "ILT" &&
          trainerContinueTeachingClass?.toLowerCase() != "self" &&
          learners.response.total > 0
        ) {
          setAutoAssignVisible(true);
          autoAssignFunction();
        } else {
          navigation(-1);
        }
      }
    } else {
      let logResponse = await userLogs(logObj);
      if (actionType == "finish") {
        if (
          assetMode == "ILT" &&
          trainerContinueTeachingClass?.toLowerCase() != "self" &&
          learners.response.total > 0
        ) {
          setAutoAssignVisible(true);
          autoAssignFunction();
        } else {
          navigation(-1);
        }
      } else {
        dispatch(
          currentAssetSliceActions.setTrainerContinueTeachingLog(
            logResponse.data
          )
        );
      }
    }
  };

  let autoAssignFunction = () => {
    let module;
    if (language > -1) {
      module = find(
        JSON.parse(product[0]["course_data"])["data"][0]["data"][language][
          "data"
        ],
        {
          id: moduleId,
        }
      );
    } else {
      module = find(JSON.parse(product[0]["course_data"])["data"][0]["data"], {
        id: moduleId,
      });
    }
    let session = find(module.data, { id: sessionId });
    let practice_node = find(session.data, { value: "Practice Session" });
    if (!practice_node) {
      setAutoAssignVisible(false);
      navigation(-1);
      return false;
    }
    let cbtnode = find(practice_node.data, { value: "CBT" });
    let dateObj = new Date();
    let data = {};
    data["assets"] = cbtnode.data;
    data["title"] = `${session.value.replaceAll("$", "")} #${randomNumber(
      5000
    )}`;
    data["description"] = `"${module.value}->${session.value}"`;
    data["startDate"] = getFormatedDateTime(dateObj.getTime());
    data["endDate"] = getFormatedDateTime(
      dateObj.getTime() +
        +process.env.REACT_APP_AUTO_ASSIGNMENT_DEFAULT_VALIDITY *
          24 *
          60 *
          60 *
          1000
    );
    setAutoAssignViewData(data);
  };

  let autoAssignTask = async () => {
    let autoTask = await autoCreateTask(
      autoAssignViewData?.assets,
      autoAssignViewData?.title,
      autoAssignViewData?.description,
      userInfo,
      productId,
      "assets"
    );

    let taskData = {
      uid: autoTask.uid,
      estimated_time: autoTask.estimated_time,
    };

    let autoAssign = await autoCreateAssignment(
      trainerContinueTeachingClass,
      autoAssignViewData?.title,
      autoAssignViewData?.description,
      userInfo,
      taskData,
      autoAssignViewData?.startDate,
      autoAssignViewData?.endDate
    );

    if (autoAssign.status == 200) {
      navigation(-1);
    }
  };

  let autoAssignTaskEdit = async () => {
    let autoTask = await autoCreateTask(
      autoAssignViewData?.assets,
      autoAssignViewData?.title,
      autoAssignViewData?.description,
      userInfo,
      productId,
      "assets"
    );

    let taskData = {
      uid: autoTask.uid,
      estimated_time: autoTask.estimated_time,
    };

    let assignssignObj = await prepareAssignObj(
      trainerContinueTeachingClass,
      autoAssignViewData?.title,
      userInfo,
      taskData,
      autoAssignViewData?.startDate,
      autoAssignViewData?.endDate
    );

    sessionStorage.setItem("autoAssignEditObj", JSON.stringify(assignssignObj));

    navigation("/Assign/Create/assets");
  };

  let getAssetData = async () => {
    if (assetsList && assetsList[currentAssetIndex]) {
      let assetData = await getAsset(assetsList[currentAssetIndex]["id"]);
      console.log(":S:S:S::S:S", assetData);

      if (serverRole != "" && serverRole != "WEB_HOST") {
        let myId = assetData.data[0].asset_uid;
        let assetDataLocal = { ...assetData.data[0] };
        assetDataLocal.asset_uid = null;
        setAssetData(assetDataLocal);
        setTimeout(() => {
          assetDataLocal.asset_uid = myId;
          setAssetData(assetDataLocal);
        }, [500]);
      }

      setAssetData(assetData.data[0]);
      checkEvalMode(assetData.data[0]);
      dispatch(currentAssetSliceActions.setAssetData(assetData.data[0]));
    }
  };

  let insertIntervalDropLog = async () => {
    let logObj = {
      actor: userInfo.uid,
      verb: "courseView",
      outcome: assetLogObj,
      site_uuid: userInfo.site_uuid,
      target: null,
      context: {
        assetId: assetsList[currentAssetIndex]["id"],
        classId: trainerContinueTeachingClass,
        className: trainerContinueTeachingClassName,
        topicPath: breadcrumb,
      },
      session_uid: null,
    };

    logObj["outcome"] = {
      ...assetLogObj,
      duration: durationCalculate(duration, durationStartTimeStamp),
    };
    // console.log("insertIntervalDropLog", logObj);
    // return false;
    if (logObj["outcome"]["duration"] > 0) {
      let logResponse = await userLogs(logObj);
      console.log("insertIntervalDropLog", logResponse);
    }
  };

  let updateIntervalDropLog = async () => {
    let userLogRes = await getUserLastLogData();
    if (userLogRes.length > 0) {
      let resLogObj = userLogRes[0];
      if (resLogObj.verb == "courseView") {
        console.log(
          "updateIntervalDropLog==>",
          duration,
          durationStartTimeStamp
        );
        if (resLogObj.context.assetId == assetsList[currentAssetIndex]["id"]) {
          resLogObj["outcome"]["duration"] = durationCalculate(
            duration,
            durationStartTimeStamp
          );
          //Update logs
          return await updateLog(
            resLogObj["outcome"],
            resLogObj["context"],
            resLogObj["uid"],
            userInfo.site_uuid
          );
        }
      }
    }
    // return logName;
  };

  const checkMediaAvailability = () => {
    if (
      assetData &&
      assetData.content &&
      assetData.content.content &&
      assetData.content.content.epage &&
      assetData.content.content.epage.instruction &&
      assetData.content.content.epage.instruction.media
    ) {
      let media = assetData.content.content.epage.instruction.media;
      if (
        (assetData.content.content.epage.options.question &&
          assetData.content.content.epage.options.question.text &&
          unicodeToString(
            assetData.content.content.epage.options.question.text
          ).trim()) ||
        media.image ||
        media.audio ||
        (typeof media.article == "string" && media.article) ||
        (typeof media.article == "object" &&
          media.article.length > 0 &&
          media.article[0]["text"].trim() != "")
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  const checkEvalMode = (asset) => {
    if (
      asset &&
      manualEvalAssetTypes.indexOf(
        asset.content.content.info.asset_type_alias
      ) != -1
    ) {
      if (asset.content.content.info.asset_type_alias == "DIC") {
        if (
          asset.content.content.epage.options.autoMode &&
          asset.content.content.epage.options.autoMode.toString() !== "true"
        ) {
          setEvalMode("manual");
        } else {
          setEvalMode("auto");
        }
      } else {
        setEvalMode("manual");
      }
    } else {
      setEvalMode("auto");
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClose1 = () => {
    setStateSnackbar({ ...stateSnackbar, open1: false });
  };

  const getUserLastLogData = async () => {
    let params = {
      query: {
        actor: userInfo.uid,
        verb: "courseView",
        context: {
          assetId: assetsList[currentAssetIndex]["id"],
        },
        $sort: {
          created_at: -1,
        },
        site_uuid: userInfo.site_uuid,
        $limit: 1,
      },
    };
    let userLogRes = await getUserLogs(params);
    return userLogRes.data.data;
  };

  const onVisibilityChange = async () => {
    if (document.visibilityState !== "visible") {
      // console.log("Focus Out!", duration, durationStartTimeStamp);
      clearInterval(interval);
      dispatch(currentAssetSliceActions.stopDuration());
      dispatch(currentAssetSliceActions.setDurationFlag(false));
    } else {
      dispatch(currentAssetSliceActions.setDurationFlag(true));
      dispatch(currentAssetSliceActions.startDuration());
      console.log("Focus In", duration, durationStartTimeStamp);
      startInterval();
    }
  };

  const dropDefaultRating = async (ratingValue) => {
    let logObj = {
      actor: userInfo.uid,
      verb: "ratingAssignment",
      outcome: { session_uid: sessionUid, learnerRating: ratingValue },
      site_uuid: userInfo.site_uuid,
      target: assignmentId,
      context: null,
      session_uid: null,
    };
    let logResponse = await userLogs(logObj);
    if (logResponse && logResponse.data) {
      setDefaultRatingLog(logResponse.data);
      setRatingVisible(true);
    }
  };

  const dropSpecialAssessmentLog = async () => {
    let logObj = {
      actor: userInfo.uid,
      verb: "specialExamLog",
      outcome: { session_uid: sessionUid },
      site_uuid: userInfo.site_uuid,
      target: assignmentId,
      context: null,
      session_uid: null,
    };
    let logResponse = await userLogs(logObj);
  };

  return (
    <Grid
      container
      sx={{
        flexDirection: "row",
        justifyContent: "flex-start",
      }}
      key={assetData ? assetData.asset_uid : "1"}
    >
      <Grid item xs={12} sx={{}}>
        {assetData &&
          assetData.content.content.info.asset_type_alias !== "ILT" && (
            <InstructionCard
              text={unicodeToString(
                assetData.content.content.epage.instruction.text
              )}
              avpairText={
                assetData?.content?.content?.epage?.instruction?.multi_text
                  ?.length > 0
                  ? assetData?.content?.content?.epage?.instruction?.multi_text
                  : false
              }
              totalAsets={assetsList.length}
              jumpTo={(page) => {
                setCurrentAssetIndex(page);
              }}
              globalObject={
                assetData?.content?.content?.epage?.global_object
                  ? assetData?.content?.content?.epage?.global_object
                  : ""
              }
              info={assetData.content.content.info}
            />
          )}
      </Grid>
      <Grid item xs={12} sx={{}}>
        <Box
          sx={{
            border: 1,
            borderColor: "#EAECEE",
            borderRadius: 3,
            py:
              assetData &&
              ILTTypeAssets.indexOf(
                assetData.content.content.info.asset_type_alias
              ) == -1
                ? "2"
                : "0",
            mx: 6,
            mt: 1,
            height:
              assetData &&
              assetData.content.content.info.asset_type_alias.toUpperCase() ==
                "ILT"
                ? "78vh"
                : "69.5vh",
          }}
        >
          <Grid
            container
            sx={{
              position: "relative",
              flexDirection: "row",
              flexFlow: "wrap",
              justifyContent: "center",
              px:
                assetData &&
                ILTTypeAssets.indexOf(
                  assetData.content.content.info.asset_type_alias
                ) == -1
                  ? 2
                  : 0,
              gap: 3,
            }}
          >
            {assetData?.content?.content?.info?.asset_type_alias?.toUpperCase() ==
              "ILT" &&
              userInfo?.rolesInfo?.title?.toLowerCase() !== "learner" && (
                <Grid item sx={{ position: "absolute", right: 5, top: 14 }}>
                  <IconButton
                    sx={{
                      color: "#FFFFFF",
                      backgroundColor: "#5f5600ff",
                      mx: 1,
                      padding: 0,
                     
                    }}
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  >
                    <MoveDownIcon
                      sx={{
                        borderRadius: "50%",
                        padding: 1,
                        "@media (min-width: 1636px)": {
                          fontSize: "2.2rem",
                        },
                      }}
                    />
                  </IconButton>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    {assetsList?.length &&
                      new Array(assetsList?.length)
                        .fill("")
                        .map((val, assetIndex) => {
                          return (
                            <MenuItem
                              onClick={() => {
                                setCurrentAssetIndex(assetIndex);
                                setAnchorEl(null);
                              }}
                            >
                              {assetIndex + 1}
                            </MenuItem>
                          );
                        })}
                  </Menu>
                </Grid>
              )}
            {assetData &&
              checkMediaAvailability() &&
              (ILTTypeAssets.indexOf(
                assetData.content.content.info.asset_type_alias
              ) == -1 ||
                FullWidthAssets.indexOf(
                  assetData.content.content.info.asset_type_alias
                ) != -1) && (
                <Grid item xs={4} sx={{ textAlign: "center", mt: 2 }}>
                  <MediaCard
                    article={
                      assetData.content.content.epage.instruction.media.article
                    }
                    image={
                      assetData.content.content.epage.instruction.media.image
                    }
                    audio={
                      assetData.content.content.epage.instruction.media.audio
                    }
                    video={
                      assetData.content.content.epage.instruction.media.video
                    }
                    questionText={
                      assetData.content?.content?.epage?.options?.question?.text
                    }
                  />
                </Grid>
              )}
            <Grid
              item
              xs={
                assetData &&
                ILTTypeAssets.indexOf(
                  assetData.content.content.info.asset_type_alias
                ) != -1
                  ? 12
                  : assetData &&
                    FullWidthAssets.indexOf(
                      assetData.content.content.info.asset_type_alias
                    ) != -1
                  ? 12
                  : 7
              }
            >
              {assetData && (
                <ContentTypeCheck
                  content={assetData.content.content}
                ></ContentTypeCheck>
              )}
            </Grid>
          </Grid>
        </Box>
      </Grid>
      {!isViewOnly && !isViewOnlyWithoutAttempt && (
        <Grid item xs={12} sx={{}}>
          {assetData &&
            !assetData.content.content.info.is_presentation &&
            ILTTypeAssets.indexOf(
              assetData.content.content.info.asset_type_alias
            ) == -1 && (
              <CBTFooterCard
                currentPage={currentAssetIndex}
                totalPage={assetsList.length}
                assetType={assetData.content.content.info.asset_type_alias}
                evalMode={evalMode}
                ignoreNextPre={ignoreNextPre}
                next={() => {
                  dropLog("next");
                }}
                previous={() => {
                  dropLog("previous");
                }}
                finishClick={(type) => {
                  dropLog("finish", type);
                }}
              />
            )}
          {assetData &&
            (assetData.content.content.info.is_presentation ||
              ILTTypeAssets.indexOf(
                assetData.content.content.info.asset_type_alias
              ) != -1) && (
              <ILTFooterCard
                currentPage={currentAssetIndex}
                totalPage={assetsList.length}
                assetType={assetData.content.content.info.asset_type_alias}
                evalMode={evalMode}
                ignoreNextPre={ignoreNextPre}
                controlButton={
                  assetData.content.content.epage.options.content.action_button
                }
                next={() => {
                  dropLog("next");
                }}
                previous={() => {
                  dropLog("previous");
                }}
                finishClick={(type) => {
                  dropLog("finish", type);
                }}
              />
            )}
        </Grid>
      )}
      {isViewOnly && assetData && (
        <UserAnswers content={assetData.content.content}></UserAnswers>
      )}
      <RatingModal
        visible={ratingVisible}
        toggleModal={(flag) => setRatingVisible(flag)}
        done={(rating) => {
          ratingDone(rating);
        }}
      ></RatingModal>
      <Confirmation
        visible={timeUp}
        primaryText={"Time up!"}
        image={"error"}
        toggleModal={(flag) => {
          dispatch(currentAssetSliceActions.setTimeUp(flag));
        }}
        persistent={true}
        secondaryText={""}
        confirmText={"OK"}
        confirm={() => {
          if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
            dispatch(currentAssetSliceActions.setTimeUp(true));
            dropDefaultRating(1);
          }
        }}
      ></Confirmation>
      {/* <Confirmation
        visible={errVisible}
        primaryText={errMsg}
        image={"error"}
        toggleModal={(flag) => setErrVisible(flag)}
        secondaryText={""}
        confirmText={"OK"}
        confirm={() => {
          setErrVisible(false);
        }}
      ></Confirmation> */}
      <AutoAssignModal
        visible={autoAssignVisible}
        title={autoAssignViewData?.title}
        startDate={autoAssignViewData?.startDate}
        endDate={autoAssignViewData?.endDate}
        toggleModal={(flag) => {
          setAutoAssignVisible(flag);
          navigation(-1);
        }}
        assign={autoAssignTask}
        edit={autoAssignTaskEdit}
      ></AutoAssignModal>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={7000}
        open={open1}
        onClose={handleClose1}
        key={vertical + horizontal}
      >
        <Alert
          variant="filled"
          severity="info"
          icon={
            <SignalWifiStatusbarConnectedNoInternet4Icon
              sx={{ marginLeft: 1 }}
            />
          }
        ></Alert>
      </Snackbar>
    </Grid>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default Content;
